import React from "react";
import {
  Typography,
  Box,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import PopupModal from "./PopupModal";
import Btn from "./Btn";
import TextFieldComponent from "../TextFieldComponent";

const RequestChangeModal = ({
  open,
  onClose,
  field,
  oldValue,
  newValue,
  reason,
  setNewValue,
  setReason,
  onSubmit,
}) => {
  if (!open) return null;

  const isFreelancerField = field === "freelancer";

  return (
    <PopupModal
      maxWidth="sm"
      size="sm"
      open={open}
      handleClose={onClose}
      title={
        <Typography variant="subtitle1" fontWeight={600}>
          Request change for <strong>{field}</strong>
        </Typography>
      }
      actions={
        <Grid container spacing={1} justifyContent="flex-end">
          <Grid item>
            <Btn variant="outlined" onClick={onClose}>
              Cancel
            </Btn>
          </Grid>
          <Grid item>
            <Btn variant="contained" onClick={onSubmit}>
              Submit
            </Btn>
          </Grid>
        </Grid>
      }
    >
      <Box>
        <Grid container spacing={1.5}>
          {/* Current value */}
          <Grid item xs={12}>
            {isFreelancerField ? (
              <>
                <Typography variant="caption" color="text.secondary">
                  Current value
                </Typography>
                <FormControl fullWidth>
                  <RadioGroup row value={oldValue}>
                    <FormControlLabel
                      value="freelancer"
                      control={<Radio disabled />}
                      label="Freelance"
                    />
                    <FormControlLabel
                      value="translation"
                      control={<Radio disabled />}
                      label="Translation Agency"
                    />
                  </RadioGroup>
                </FormControl>
              </>
            ) : (
              <TextFieldComponent
                label="Current value"
                value={oldValue || ""}
                fullWidth
                size="small"
                variant="filled"
                disabled
              />
            )}
          </Grid>

          {/* New value */}
          <Grid item xs={12}>
            {isFreelancerField ? (
              <>
                <Typography variant="caption" color="text.secondary">
                  New value
                </Typography>
                <FormControl fullWidth>
                  <RadioGroup
                    row
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                  >
                    <FormControlLabel
                      value="freelancer"
                      control={<Radio />}
                      label="Freelance"
                    />
                    <FormControlLabel
                      value="translation"
                      control={<Radio />}
                      label="Translation Agency"
                    />
                  </RadioGroup>
                </FormControl>
              </>
            ) : (
              <TextFieldComponent
                label="New value"
                placeholder="Enter new value"
                value={newValue || ""}
                onChange={(e) => setNewValue(e.target.value)}
                fullWidth
                size="small"
                required
              />
            )}
          </Grid>

          {/* Reason */}
          <Grid item xs={12}>
            <TextFieldComponent
              label="Reason for change"
              placeholder="Briefly explain why this change is needed"
              value={reason || ""}
              onChange={(e) => setReason(e.target.value)}
              fullWidth
              size="small"
              required
              multiline
              rows={2}
            />
          </Grid>
        </Grid>
      </Box>
    </PopupModal>
  );
};

export default RequestChangeModal;
